import { CompanyTaxInterface } from '../companies/types';

/*
 * Action Types
 */
export enum TaxTypes {
  LIST_TAX_REQUEST = '@tax/LIST_TAX_REQUEST',
  LIST_TAX_SUCCESS = '@tax/LIST_TAX_SUCCESS',
  LIST_TAX_FAILURE = '@tax/LIST_TAX_FAILURE',

  GET_TAX_REQUEST = '@tax/GET_TAX_REQUEST',
  GET_TAX_SUCCESS = '@tax/GET_TAX_SUCCESS',
  GET_TAX_FAILURE = '@tax/GET_TAX_FAILURE',

  CREATE_TAX_REQUEST = '@tax/CREATE_TAX_REQUEST',
  CREATE_TAX_SUCCESS = '@tax/CREATE_TAX_SUCCESS',
  CREATE_TAX_FAILURE = '@tax/CREATE_TAX_FAILURE',

  UPDATE_TAX_REQUEST = '@tax/UPDATE_TAX_REQUEST',
  UPDATE_TAX_SUCCESS = '@tax/UPDATE_TAX_SUCCESS',
  UPDATE_TAX_FAILURE = '@tax/UPDATE_TAX_FAILURE',

  DELETE_TAX_REQUEST = '@tax/DELETE_TAX_REQUEST',
  DELETE_TAX_SUCCESS = '@tax/DELETE_TAX_SUCCESS',
  DELETE_TAX_FAILURE = '@tax/DELETE_DBD_FAILURE',

  ATTACH_TAX_REQUEST = '@tax/ATTACH_TAX_REQUEST',
  ATTACH_TAX_SUCCESS = '@tax/ATTACH_TAX_SUCCESS',
  ATTACH_TAX_FAILURE = '@tax/ATTACH_TAX_FAILURE',

  DETACH_TAX_REQUEST = '@tax/DETACH_TAX_REQUEST',
  DETACH_TAX_SUCCESS = '@tax/DETACH_TAX_SUCCESS',
  DETACH_TAX_FAILURE = '@tax/DETACH_DBD_FAILURE',
}

/*
 * Data types
 */

export interface TaxCompaniesInterface {
  id: string;
  name: string;
  cnpj: string;
  selected?: boolean;
  checked?: boolean;
  CompanyTax: {
    id: string;
    taxId: string;
    companyId: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface TaxInterface {
  id: string;
  name: string;
  type?: number;
  value: number;
  valueType?: number;
  status: number | boolean;
  applyForAll: boolean;
  createdAt: Date | string;
  updatedAt: Date | string;
  transportOperatorId: string;
  CompanyTax?: CompanyTaxInterface;
  checked?: boolean;
  Companies?: Array<TaxCompaniesInterface>;
}

/*
 * State type
 */
export interface TaxState {
  readonly taxList: TaxInterface[];
  readonly taxData: TaxInterface | null;
  readonly loading: boolean;
  readonly error: boolean;
}
